import { FeatureEnum } from "../enums/FeatureEnum";
import { useAccessControl } from "./useAccessControl";

export const useIsFeatureAllowed = (feature: FeatureEnum) => {
  const { hasFeature } = useAccessControl();

  return hasFeature(feature);
};
